import type { Module } from 'vuex';
import { Country } from '@/types/Country';
import {RootState} from "@/store";

export interface CountriesState {
  countries: Country[];
}

const countriesModule: Module<CountriesState, RootState> = {
  namespaced: true,

  state: (): CountriesState => ({
    countries: [],
  }),

  mutations: {
    setCountries(state, payload: { countries: Record<number, any> }) {
      state.countries = Object.values(payload.countries).map(raw => Country.fromRaw(raw));
    },

    setCountryCreate(state, payload: any) {
      state.countries.push(Country.fromRaw(payload));
    },

    setCountryUpdate(state, payload: any) {
      const idx = state.countries.findIndex(country => country.idCountry === payload.idCountry);
      if (idx === -1) return;
      state.countries[idx] = { ...state.countries[idx], ...payload };
    },

    setCountryDelete(state, payload: { idCountry: number }) {
      state.countries = state.countries.filter(country => country.idCountry !== payload.idCountry);
    },

    setCountryLock(state, payload: { idCountry: number }) {
      const country = state.countries.find(country => country.idCountry === payload.idCountry);
      if (country) country.locked = true;
    },
    setCountryUnlock(state, payload: { idCountry: number }) {
      const country = state.countries.find(country => country.idCountry === payload.idCountry);
      if (country) country.locked = false;
    },
  },
  actions: {
    wsSetCountries({ commit }, payload) {
      commit('setCountries', payload);
    },
    wsCountryCreate({ commit }, payload) {
      commit('setCountryCreate', payload);
    },
    wsCountryUpdate({ commit }, payload) {
      commit('setCountryUpdate', payload);
    },
    wsCountryDelete({ commit }, payload) {
      commit('setCountryDelete', payload);
    },
    wsCountryLock({ commit }, payload) {
      commit('setCountryLock', payload);
    },
    wsCountryUnlock({ commit }, payload) {
      commit('setCountryUnlock', payload);
    },
  },
};

export default countriesModule;